/* eslint-disable import/prefer-default-export */

import createAction from '@clearscore-group/lib.helpers.create-action';

import { COOKIE_POLICY_ACCEPT } from '../cookie-policy.types';

export const acceptCookiePolicy = () => createAction(COOKIE_POLICY_ACCEPT);
